import { z } from "zod";
import { entitySchema, nanoidSchema } from "../utility/index.js";
var ConfigVersion = /* @__PURE__ */ ((ConfigVersion2) => {
  ConfigVersion2["V1"] = "1.0.0";
  ConfigVersion2["V2"] = "2.0.0";
  return ConfigVersion2;
})(ConfigVersion || {});
const publishRecordSchema = entitySchema.extend({
  projectUid: nanoidSchema,
  status: z.union([
    z.literal("pending"),
    z.literal("building"),
    z.literal("deployed"),
    z.literal("inactive"),
    z.literal("error"),
    z.literal("deleted")
  ]),
  deployedAt: z.number().nullable().default(null),
  message: z.string().default(""),
  domain: z.string().default(""),
  preview: z.boolean().optional().default(false),
  commitSha: z.string().nullable().default(null),
  version: z.enum(ConfigVersion).default("1.0.0" /* V1 */),
  subpath: z.string().nullable().default(null)
}).meta({ id: "publish-record" });
export {
  ConfigVersion,
  publishRecordSchema
};
//# sourceMappingURL=publish.js.map
